import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URLConstants } from '../utility/url-constants';
import { BaseService } from 'src/app/core/services/base.httpService';
import { handleErrorMessage } from '../operators/error.operator';

@Injectable({
  providedIn: 'root',
})
export class CommonApiService {
  public errorHandler = handleErrorMessage();

  constructor(private readonly baseService: BaseService) {}

  public getDepartmentAndRoles(): Observable<any> {
    return this.baseService.initiateApiRequest(
      'GET',
      URLConstants.getDepartmentAndRole,
      '',
      'json'
    );
  }

  public validateAPMawbLineHaul(event: any): Observable<any> {
    return this.baseService.initiateApiRequest(
      'POST',
      URLConstants.validateMawbLineHaul,
      event,
      '',
      'json'
    );
  }

  public validateAccountNumber(accountNumber: string): Observable<any> {
    return this.baseService
      .initiateApiRequest(
        'GET',
        URLConstants.validateAccount + encodeURIComponent(accountNumber),
        '',
        'json'
      )
      .pipe(this.errorHandler());
  }
}
